import { ErrorBoundary } from "../../../components";
import loadable from "@loadable/component";
import FullPageLoader from "@Components/FullPageLoader";
import useAbTestVariant from "hooks/useAbTestVariant";

const ScholarshipDesktop = loadable(() => import("./ScholarshipDesktop"), {
  fallback: <FullPageLoader />,
});

const ScholarshipNewDesktop = loadable(
  () => import("../../ScholarshipNew/Desktop/ScholarshipNewDesktop"),
  {
    fallback: <FullPageLoader />,
  },
);

export default (props: any): JSX.Element => {
  const variant = useAbTestVariant("scholarship_variant");

  return (
    <ErrorBoundary>
      {variant === "new" ? <ScholarshipNewDesktop {...props} /> : <ScholarshipDesktop {...props} />}
    </ErrorBoundary>
  );
};
